import { render, staticRenderFns } from "./BannerTextEdit.vue?vue&type=template&id=254f50a6&"
import script from "./BannerTextEdit.vue?vue&type=script&lang=js&"
export * from "./BannerTextEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports